"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStartPlaybackAttemptState = exports.updatePlayerLoadingState = exports.updateNextTrackStartSchedule = exports.setCurrentPlayState = exports.setPlaylistUpdateState = exports.setRequiredPlayState = exports.setPlayerVolume = void 0;
var types_1 = require("../types");
var setStalledState_1 = __importDefault(require("../actions/playback/setStalledState"));
var initialState = {
    currentPlayState: types_1.EPlayState.STOP,
    requiredPlayState: types_1.EPlayState.STOP,
    volume: 1,
    playerStalled: false,
    startPlaybackAttempt: {
        success: false,
        time: null,
        failureReason: null,
    },
};
function setPlayerVolume(volume) {
    return {
        type: setPlayerVolume.type,
        payload: { volume: volume },
    };
}
exports.setPlayerVolume = setPlayerVolume;
setPlayerVolume.type = "player/setVolume";
function setRequiredPlayState(state) {
    return {
        type: setRequiredPlayState.type,
        payload: { state: state },
    };
}
exports.setRequiredPlayState = setRequiredPlayState;
setRequiredPlayState.type = "player/setRequiredPlayState";
function setPlaylistUpdateState(state) {
    return {
        type: setPlaylistUpdateState.type,
        payload: { state: state },
    };
}
exports.setPlaylistUpdateState = setPlaylistUpdateState;
setPlaylistUpdateState.type = "player/setPlaylistUpdateState";
function setCurrentPlayState(state) {
    return {
        type: setCurrentPlayState.type,
        payload: { state: state },
    };
}
exports.setCurrentPlayState = setCurrentPlayState;
setCurrentPlayState.type = "player/setCurrentPlayState";
function updateNextTrackStartSchedule(nextStart) {
    return {
        type: updateNextTrackStartSchedule.type,
        payload: { nextStart: nextStart },
    };
}
exports.updateNextTrackStartSchedule = updateNextTrackStartSchedule;
updateNextTrackStartSchedule.type = "player/updateNextTrackStartSchedule";
function updatePlayerLoadingState(state) {
    return {
        type: updatePlayerLoadingState.type,
        payload: { state: state },
    };
}
exports.updatePlayerLoadingState = updatePlayerLoadingState;
updatePlayerLoadingState.type = "player/updatePlayerLoadingState";
function updateStartPlaybackAttemptState(state) {
    return {
        type: updateStartPlaybackAttemptState.type,
        payload: { state: state },
    };
}
exports.updateStartPlaybackAttemptState = updateStartPlaybackAttemptState;
updateStartPlaybackAttemptState.type = "player/updateStartPlaybackAttemptState";
function playerReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case setRequiredPlayState.type:
            return __assign(__assign({}, state), { requiredPlayState: action.payload.state, lastRequiredPlayState: action.payload.state });
        case setCurrentPlayState.type:
            return __assign(__assign({}, state), { currentPlayState: action.payload.state });
        case setPlayerVolume.type:
            return __assign(__assign({}, state), { volume: action.payload.volume });
        case updateNextTrackStartSchedule.type:
            return __assign(__assign({}, state), { nextTrackWillStartAt: action.payload.nextStart });
        case setPlaylistUpdateState.type:
            return __assign(__assign({}, state), { playlistIsUpdating: action.payload.state });
        case updatePlayerLoadingState.type:
            return __assign(__assign({}, state), { playerLoading: action.payload.state });
        case setStalledState_1.default.type:
            return __assign(__assign({}, state), { playerStalled: action.payload.isStalled });
        case updateStartPlaybackAttemptState.type:
            return __assign(__assign({}, state), { startPlaybackAttempt: action.payload.state });
        default:
            return state;
    }
}
exports.default = playerReducer;
//# sourceMappingURL=player.js.map